import React from 'react';
import type { FC } from 'react';
import { FormattedMessage } from 'react-intl-next';

import SectionMessage, { SectionMessageAction } from '@atlaskit/section-message';

import { MutationErrorContainer } from './styled.tsx';
import { i18n } from './utils/i18n.ts';

type ReactionsMutationErrorProps = {
	isPage: boolean;
	resetErrorStates: () => void;
	addMutationError?: Error;
	deleteMutationError?: Error;
};

export const ReactionsMutationError: FC<ReactionsMutationErrorProps> = ({
	isPage,
	resetErrorStates,
	addMutationError,
	deleteMutationError,
}) =>
	isPage && (addMutationError || deleteMutationError) ? (
		<MutationErrorContainer>
			<SectionMessage
				appearance="error"
				actions={
					<SectionMessageAction onClick={resetErrorStates}>
						<FormattedMessage {...i18n.mutationErrorAction} />
					</SectionMessageAction>
				}
			>
				<FormattedMessage
					{...(addMutationError ? i18n.addMutationError : i18n.deleteMutationError)}
				/>
			</SectionMessage>
		</MutationErrorContainer>
	) : null;
